(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("marked"), require("vue"), require("highlight.js"));
	else if(typeof define === 'function' && define.amd)
		define(["marked", , "highlight.js"], factory);
	else if(typeof exports === 'object')
		exports["vue-comment"] = factory(require("marked"), require("vue"), require("highlight.js"));
	else
		root["vue-comment"] = factory(root["marked"], root["Vue"], root["highlight.js"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__1d61__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_f4e8__) {
return 